import Panel from './panel';
import { tagOnClick, encodeURL, displayVideo, displayImage } from '../utils';
import environment from '../environment';

const shareServers = {
  production: 'https://share.movablecamera.com/',
  staging: 'https://og-page-maker-staging.herokuapp.com'
};
const shareServer = shareServers[environment] || shareServers.production;

const { E } = Math;
const defaultFacebookAppId = '503368366789545';

const arShareProcessorURL = 'https://put.movablecamera.com/upload';

export default class SharePanel extends Panel {
  render() {
    tagOnClick(this.getTag('back-button'), () => {
      this.parent.transitionToPanel('review');
    });

    tagOnClick(this.getTag('share-to-facebook'), () => {
      this.parent.sendEvent('share', { share_to: 'facebook' });
      this.shareToFacebook();
    });

    tagOnClick(this.getTag('share-to-twitter'), () => {
      this.parent.sendEvent('share', { share_to: 'twitter' });
      this.shareToTwitter();
    });

    tagOnClick(this.getTag('share-to-whatsapp'), () => {
      this.parent.sendEvent('share', { share_to: 'whatsapp' });
      this.shareToWhatsApp();
    });

    tagOnClick(this.getTag('share-to-linkedin'), () => {
      this.parent.sendEvent('share', { share_to: 'linkedin' });
      this.shareToLinkedIn();
    });
  }

  activate() {
    const shareImageTag = this.getTag('share-image');
    shareImageTag.element.innerHTML = '';

    if (this.parent.blobby.type.includes('video')) {
      displayVideo(shareImageTag, this.parent.imageDataURL);
    } else {
      displayImage(shareImageTag, this.parent.imageDataURL);
    }

    this.parent.upload = null;
  }

  deactivate() {
    const shareImageTag = this.getTag('share-image');
    shareImageTag.element.innerHTML = '';
  }

  uploadImage(blob) {
    blob = new Blob([E.toFixed(10), blob], { type: blob.type.replace(/;.*/, '') });
    const type = blob.type.match(/image\/gif|video/) ? 'video' : 'image';

    return new Promise((resolve, reject) => {
      const putUrl = arShareProcessorURL;
      const putXHR = new XMLHttpRequest();
      putXHR.open('PUT', putUrl, true);

      const response = () => {
        let data;
        try {
          data = JSON.parse(putXHR.responseText);
        } catch (e) {
          throw `Problem parsing JSON: ${putXHR.responseText}`;
        }

        if (data.status === 'done') {
          resolve({ landingPage: this.generateShareURL(data.uuid, type) });
        } else {
          console.log(data);
        }
      };

      putXHR.onload = response;
      putXHR.onprogress = response;

      putXHR.onerror = e => {
        reject(e);
      };

      this.parent.upload = putXHR.upload;

      this.parent.transitionToPanel('uploading');

      putXHR.send(blob);
    });
  }

  generateShareURL(imageKey, type) {
    return encodeURL(shareServer, {
      t: this.parent.options.share_title, // title
      i: imageKey,
      type,
      d: this.parent.options.share_message || '', // description
      app_key: this.parent.appKey,
      share_page: 1,
      url: this.parent.options.share_landing_page_url // cta link
    });
  }

  generateShareText(landingPage) {
    return [this.parent.options.share_message, landingPage].filter(Boolean).join(' ');
  }

  shareToFacebook() {
    return this.uploadImage(this.parent.blobby).then(({ landingPage }) => {
      this.parent.shareURL = encodeURL('https://www.facebook.com/dialog/feed', {
        app_id: this.parent.options.facebook_app_id || defaultFacebookAppId,
        display: 'page',
        picture: landingPage,
        redirect_uri: 'https://www.facebook.com'
      });
      this.parent.transitionToPanel('terms');
    });
  }

  shareToTwitter() {
    return this.uploadImage(this.parent.blobby).then(({ landingPage }) => {
      this.parent.shareURL = encodeURL('https://twitter.com/intent/tweet', {
        text: this.generateShareText(landingPage)
      });
      this.parent.transitionToPanel('terms');
    });
  }

  shareToLinkedIn() {
    return this.uploadImage(this.parent.blobby).then(({ landingPage }) => {
      this.parent.shareURL = encodeURL('https://www.linkedin.com/sharing/share-offsite/', {
        url: landingPage
      });
      this.parent.transitionToPanel('terms');
    });
  }

  shareToWhatsApp() {
    return this.uploadImage(this.parent.blobby).then(({ landingPage }) => {
      this.parent.shareURL = encodeURL('whatsapp://send', {
        text: this.generateShareText(landingPage)
      });
      this.parent.transitionToPanel('terms');
    });
  }
}
